import React from 'react';
import StarRating from './StarRating';
import {
    formatDate,
    formatRecommendationDisplay,
    formatReviewText,
    getRatingNumber,
} from '../utils/formatters';
import ReviewCardActions from './ReviewCardActions';
import { ReviewCardProps } from '../type';

const ReviewCard: React.FC<ReviewCardProps> = ({
    review,
    isNew,
    getNetworkLogo,
    onShare,
    onReply,
    onOpinionSystemRedirect,
}) => {
    const hasReply =
        typeof review.review_reply === 'object' &&
        review.review_reply !== null &&
        'comment' in review.review_reply &&
        Boolean(review.review_reply.comment);

    return (
        <div
            className={`flex flex-col flex-[1_1_calc(33.333%-14px)] box-border ${
                isNew ? 'bg-white' : 'bg-primary-light'
            } p-5 rounded-2xl border border-light-gray shadow-[0_7px_9px_rgba(141,141,141,0.10),0_4px_13px_rgba(141,141,141,0.08)] ${
                ['read', 'answered'].includes(review.status) ? 'review-card--read' : ''
            }`}
        >
            <div className="flex justify-between items-center">
                <div className="flex gap-2.5">
                    <img
                        className="flex p-1.5 justify-center items-center w-[36px] rounded-[6px] bg-[var(--extra-light-gray)]"
                        src={getNetworkLogo(review.network)}
                        alt={review.network}
                    />
                    <div className="reviewer-rating">
                        <h3 className="text-[18px] text-[#333333] font-heavy m-0 overflow-hidden text-ellipsis whitespace-nowrap max-w-[200px]">
                            {review.reviewer}
                        </h3>
                        <div className="h-[15px] flex">
                            {review.network === 'google_my_business' ||
                            review.network === 'opinion_system' ? (
                                <StarRating rating={getRatingNumber(review.rating)} />
                            ) : (
                                formatRecommendationDisplay(review.rating)
                            )}
                        </div>
                    </div>
                </div>
                <div className="flex items-center gap-4 text-[var(--gray)] text-[10px] font-normal leading-[120%]">
                    {isNew && (
                        <span className="text-[var(--dark-gray,#393939)] text-[10px] font-bold leading-[120%] uppercase">
                            NOUVEAU
                        </span>
                    )}
                    <span className="text-[var(--gray,#767676)] text-[10px] font-normal leading-[120%]">
                        {formatDate(review.created_at)}
                    </span>
                </div>
            </div>

            <p className="text-[var(--dark-gray,#393939)] text-medium-small font-normal leading-[120%] my-5">
                {review.text !== '' ? (
                    <>{formatReviewText(review.text)}</>
                ) : (
                    <span style={{ fontStyle: 'italic' }}>
                        Aucun commentaire n'a été laissé par l'utilisateur.
                    </span>
                )}
            </p>

            {hasReply &&
                typeof review.review_reply === 'object' &&
                review.review_reply !== null && (
                    <div
                        className="flex flex-col w-full gap-[20px] mb-5 pt-5 border-t"
                        style={{ borderColor: 'var(--light-gray, #E4E4E4)' }}
                    >
                        <div
                            className="flex flex-col gap-3.5 w-full p-3 rounded-[6px]"
                            style={{ background: 'var(--generic-white, #fff)' }}
                        >
                            <div className="flex justify-between items-center self-stretch">
                                <span className="text-[#393939] text-[13px] font-semibold leading-[120%] normal-case">
                                    Votre réponse
                                </span>
                                <span className="text-[#9B9B9B] text-[10px] font-normal leading-[120%]">
                                    {formatDate(review.review_reply.updateTime)}
                                </span>
                            </div>
                            <div className="text-[#767676] text-[14px] font-normal leading-[120%]">
                                {review.review_reply.comment}
                            </div>
                        </div>
                    </div>
                )}

            <ReviewCardActions
                review={review}
                hasReply={hasReply}
                onShare={onShare}
                onReply={onReply}
                onOpinionSystemRedirect={onOpinionSystemRedirect}
            />
        </div>
    );
};

export default ReviewCard;
